import './DbrdAnalytics.scss';

import React, { Component } from 'react';

import { AVIDashboard } from '../../chart-components/Layout/AVIDashboard';
import { DataLoader } from '../../ui-components/DataLoader/DataLoader';
import History from '../../chart-components/History';
import { Loader } from '../../ui-components/Loader/Loader';
import { NoData } from '../../ui-components/NoData/NoData';
import { TimeUtils } from '../../chart-components/ChartUtils/TimeUtils';
import crossfilter from 'crossfilter2';
import { HeatMap } from '../../chart-components/Charts/HeatMap';
import { BarChartDate } from './../../chart-components/Charts/BarChartDate';
import { RowChart } from './../../chart-components/Charts/RowChart';
import { GroupUtils } from '../../chart-components/ChartUtils/GroupUtils';
import { FilterToFromMonth } from './../../filters/FilterToFromMonth';
import { AVIRow } from './../../chart-components/Layout/AVIRow';
import { PropTypes } from 'prop-types';
import withRouter from '../../hocs/withRouter';

class DbrdAnalyticsLocal extends Component {

  static dashboardRoute = 'analytics';

  static dashboardFilters(filter, setFilter, passlines, renderSelection) {
    return {
      helpMessage: 'Analytics genererer mye data',
      controls: [
        <FilterToFromMonth key='flt-tf-month' firstYear={2022} setFilter={setFilter} filter={filter} />
      ]
    };
  }

  static dashboardSettings() {
    return {};
  }

  static dashboardValidation(filter) {
    if (filter.fromTime && filter.toTime) {
      return true;
    } else {
      return false;
    }
  }

  static propTypes = {
    location: PropTypes.shape({
      state: PropTypes.shape({
        fromTime: PropTypes.string.isRequired,
        toTime: PropTypes.string.isRequired
      })
    })
  }

  constructor(props) {
    super(props);
    this.state = {
      chartData: null
    };

    this.reportProgress = this.reportProgress.bind(this);
  }

  componentDidMount() {
    const { fromTime, toTime } = this.props.location.state;
    DataLoader.postApi(
      `/api/analytics/log/read/kystdatahuset/${fromTime.split('T')[0]}/${toTime.split('T')[0]}`,
      {},
      this.reportProgress
    ).then((res) => {
      // Check that all responses are successful
      if (!res.success) return Promise.reject(new Error('Could not load analytics data'));
      // console.log(res.data[0]);
      this.setState({
        chartData: crossfilter(res.data)
      });
    }).catch((error) => console.error(error));
  }

  reportProgress(progressData) {
    this.setState({
      progressData: progressData
    });
  }

  render() {
    const { chartData, progressData } = this.state;

    var dashboardTitle = 'Analytics';

    if (!chartData) {
      return <Loader progressData={progressData} />;
    }

    if (chartData.size() < 1) {
      return <NoData history={History} />;
    }

    var dimHourOfWeekday = chartData.dimension(d => [d.weekday, d.hour]);
    var grpHourOfWeekday = dimHourOfWeekday.group().reduceCount();

    var dimDate = chartData.dimension(d => new Date(Date.UTC(d.year, d.month - 1, d.day)));
    var grpPageLoadsByDate = dimDate.group().reduceCount();

    var dimPath = chartData.dimension(d => d.path);
    var grpPageLoadsByPath = dimPath.group().reduceCount();

    var dimRole = chartData.dimension(d => d.role);
    var grpPageLoadsByRole = dimRole.group().reduceCount();

    return (
      <div className='AppView'>
        <AVIDashboard
          title={dashboardTitle}
          desc={'Bruksdata for Kystdatahuset'}
          chartData={1}
          useFlex
          cmsSlug={DbrdAnalytics.dashboardRoute}
        >
          <AVIRow>
            <HeatMap
              chartTitle='Sidevisninger etter time i døgnet og dag i uken'
              dimension={dimHourOfWeekday}
              group={grpHourOfWeekday}
              width={4}
              height={2}
              colOrdering={TimeUtils.localeWeekDayAbbSortFunction}
              colsLabel={d => HeatMap.weekDaysNo[d - 1]}
              rowsLabel={d => HeatMap.hoursOfDay[d]}
              useFlex
            />
          </AVIRow>
          <AVIRow>
            <BarChartDate
              chartTitle='Sidevisninger etter dato'
              dimension={dimDate}
              group={grpPageLoadsByDate}
              // ordering={d => shipLengthLabels.indexOf(d.key)}
              width={4}
              height={1.5}
              filterPrefix='Dato'
              useFlex
            />
          </AVIRow>
          <AVIRow>
            <RowChart
              chartTitle='Sidevisninger etter side (15 mest besøkte)'
              width={2}
              height={2}
              dimension={dimPath}
              group={GroupUtils.RemoveEmptyBinsTopN(grpPageLoadsByPath, 15)}
              filterPrefix='Side'
              useFlex
            />
            <RowChart
              chartTitle='Sidevisninger etter rolle'
              width={2}
              height={2}
              dimension={dimRole}
              group={GroupUtils.RemoveEmptyBins(grpPageLoadsByRole)}
              filterPrefix='Rolle'
              useFlex
            />
          </AVIRow>
        </AVIDashboard>
      </div>
    );
  }
};

export const DbrdAnalytics = withRouter(DbrdAnalyticsLocal);

export default DbrdAnalytics;
